import { Chain } from "wagmi";

const ARBITRUM_GOERLI: Chain = {
  id: 421613,
  name: "Arbitrum Goerli",
  network: "arb-goerli",
  nativeCurrency: {
    name: "agor",
    symbol: "AGOR",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://scn.equilab.io/arb/goerli/rpc"] },
    public: { http: ["https://scn.equilab.io/arb/goerli/rpc"] },
  },
  testnet: true,
};

const POLYGON_MUMBAI: Chain = {
  id: 80001,
  name: "Polygon Mumbai",
  network: "polygon-mumbai",
  nativeCurrency: {
    name: "matic",
    symbol: "MATIC",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://polygon-mumbai.blockpi.network/v1/rpc/public"] },
    public: { http: ["https://polygon-mumbai.blockpi.network/v1/rpc/public"] },
  },
  testnet: true,
};

const ZKSYNC_GOERLI: Chain = {
  id: 280,
  name: "zkSync goerli",
  network: "zksync-goerli",
  nativeCurrency: {
    name: "weth",
    symbol: "WETH",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://testnet.era.zksync.dev"] },
    public: { http: ["https://testnet.era.zksync.dev"] },
  },
  testnet: true,
};

export const chains = [ARBITRUM_GOERLI, POLYGON_MUMBAI, ZKSYNC_GOERLI];
export const testNetChainsIds = chains.map((chain) => chain.id);
